import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducerState } from 'reduxStore/rootReducers';
import { FormattedMessage } from 'react-intl';
import { englishToNepaliNumber } from 'nepali-number';
import { loadable } from 'react-lazily/loadable';
const BranchAtmFilter = React.lazy(() => import('./BranchAtmFilter'));
const Card = React.lazy(() => import('./Card'));
const { NetworkStatus } = loadable(() => import('components'), {
fallback: <>Loading...</>,
});
interface Props {
	tabKey: string;
	setSelectedBranch: (branch: any) => void;
	setActiveTab: (tab: string) => void;
}

const BranchListView = ({ tabKey, setSelectedBranch, setActiveTab }: Props) => {
	const [selectedBranchId, setSelectedBranchId] = useState<null | number>(null);
	const [searchText, setSearchText] = useState('');
	const [refs, setrefs] = useState({});

	//START OUTSIDE CLICK
	const myBranchRef = useRef<any>();

	const handleClickOutside = (e) => {
		if (!myBranchRef.current.contains(e.target)) {
			setSelectedBranchId(null);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	});

	const { branchList, loading, error } = useSelector(
		({ branchListReducer }: RootReducerState) => ({
			error: branchListReducer?.branchList?.error,
			loading: branchListReducer?.branchList?.loading,
			branchList: branchListReducer?.branchList?.data,
		}),
		shallowEqual
	);

	const filterData = branchList.filter((list) => {
		if (searchText) {
			return String(list.branch_name).toLowerCase().includes(searchText) || String(list.address).toLowerCase().includes(searchText);
		} else {
			return true;
		}
	});

	useEffect(() => {
		if (branchList.length) {
			//creating refs for each cards
			let temp = branchList.reduce((acc, value) => {
				acc[value.branch_id] = React.createRef();
				return acc;
			}, {});
			setrefs(temp);
		}
	}, [branchList]);

	useEffect(() => {
		if (selectedBranchId) {
			//scrolling to that specific card position when branch is selected
			window.scrollTo({
				top: refs[selectedBranchId].current.offsetTop - refs[selectedBranchId].current.offsetHeight,
				behavior: 'smooth',
			});
		}
	}, [selectedBranchId]);
	const { locale } = useSelector(
		({ intl }: RootReducerState) => ({
			locale: intl.currentLocale,
		}),
		shallowEqual
	);
	return (
		<div className="tab-content" id="pills-tabContent">
			<div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
				<React.Suspense fallback={<div>Loading...</div>}> 
					<BranchAtmFilter handleSearch={(text) => setSearchText(text)} filterType="branch" tabKey={tabKey} setActiveTab={setActiveTab}/>
				</React.Suspense>
				{filterData.length > 0 && <div className=" pb-2 border-danger  d-flex justify-content-end align-items-center">
					<h5 className="bg-danger text-white px-2 py-1  mb-0" style={{
						borderRadius: "20px", fontSize: "12px"
					}}><FormattedMessage id="global.total" />: {locale == 'ne' ? englishToNepaliNumber(filterData.length) : filterData.length}</h5></div>}

				<NetworkStatus loading={loading} error={error} hasData={filterData.length} />

				<div className="row" ref={myBranchRef}>
					{filterData.length > 0 &&
						filterData.map((branch, index) => (
							<div ref={refs[branch.branch_id]} key={index} className="col-lg-4 col-md-3 col-sm-6 my-2 mb-4">
								<React.Suspense fallback={<div>Loading...</div>}>
									<Card selectedBranchId={selectedBranchId} setSelectedBranchId={setSelectedBranchId} branch={branch} setSelectedBranch={setSelectedBranch} setActiveTab={setActiveTab} />
								</React.Suspense>
							</div>
						))}
				</div>
			</div>
		</div>
	);
};

export default BranchListView;
